import { createContext } from 'react';

// 在卡片预览上为了hover上去不显示hoverMenu，加个Context上去
// 为了复用原有的代码迫不得已，否则就要每个块重新写一遍
export const NoBindIdContext = createContext(true);
